import { useEffect, useState } from "react";
import { useCommonComponentContext, getAllDataCodename } from "@maysoft/common-component-react";

import { CodeNameCommon } from "../../../constants/enums";
import { ICodename, ITopic } from "../../../commons/interfaces";

export type ITopicError = { [k in keyof ITopic]?: string };

const useSelectData = () => {
    const { userInfo, serviceCode, } = useCommonComponentContext();

    const [typeData, setTypeData] = useState<ICodename[]>([]);

    useEffect(() => {
        getTypeData();
    }, []);

    const getTypeData = async () => {
        const result = await getAllDataCodename({
            serviceCode: serviceCode,
            group: [CodeNameCommon.TopicType],
            organizationId: userInfo?.userProfile?.organizationId,
        });

        const newList = (result.get(CodeNameCommon.TopicType) || []).map((item) => ({ code: Number(item.code), name: item.name }));

        setTypeData(newList);
    };

    return { typeData };
};

export default useSelectData;
